/**
 * Modulo per la ricerca AJAX delle FAQ.
 * 
 * Gestisce l'input nella barra di ricerca, invia la query AJAX 
 * e visualizza i risultati in tempo reale.
 */

export function initFaqAjaxSearch() {
    const searchContainer = document.querySelector('.js-faq-search-container');
    if (!searchContainer) return;

    const input = searchContainer.querySelector('input[name="s"]');
    const resultsContainer = document.getElementById('faq-ajax-results');
    const form = searchContainer.querySelector('form');

    // Se non abbiamo localizzato le variabili (es. su altre pagine), usciamo
    if (!input || !resultsContainer || typeof faq_search_ajax === 'undefined') return;

    let timeout = null;

    input.addEventListener('input', function() {
        clearTimeout(timeout);
        const query = input.value.trim();

        if (query.length < 3) {
            resultsContainer.innerHTML = '';
            resultsContainer.classList.remove('show');
            return;
        }

        timeout = setTimeout(function() {
            fetchResults(query);
        }, 300);
    });

    // Gestione submit: BLOCCA l'invio se meno di 3 caratteri, altrimenti esegui AJAX
    form.addEventListener('submit', function(e) {
        e.preventDefault(); // Blocchiamo sempre il submit standard per non finire in search.php
        
        const query = input.value.trim();
        if (query.length >= 3) {
            fetchResults(query);
        }
    });

    function fetchResults(query) {
        resultsContainer.innerHTML = '<div class="p-3 text-center text-muted"><i class="fa fa-spinner fa-spin"></i> Ricerca in corso...</div>';
        resultsContainer.classList.add('show');

        const formData = new FormData();
        formData.append('action', 'faq_search'); // Nome dell'azione in WP
        formData.append('query', query);
        formData.append('security', faq_search_ajax.nonce); // Usiamo 'security' come atteso da check_ajax_referer

        fetch(faq_search_ajax.ajax_url, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data.length > 0) {
                renderResults(data.data);
            } else {
                resultsContainer.innerHTML = '<div class="p-3 text-center text-muted border-top border-light">Nessun risultato trovato.</div>';
            }
        })
        .catch(error => {
            console.error('Errore ricerca FAQ:', error);
            resultsContainer.innerHTML = '<div class="p-3 text-center text-danger border-top border-light">Errore durante la ricerca.</div>';
        });
    }

    function renderResults(posts) {
        let html = '<div class="accordion faq-ajax-results-accordion shadow-lg border-0 bg-white" id="faqSearchAccordion" style="z-index: 1000; position: absolute; width: 100%;">';
        posts.forEach((post, index) => {
            const itemId = `faq-search-item-${post.id}`;
            html += `
                <div class="accordion-item border-0 border-bottom border-light">
                    <h3 class="accordion-header" id="heading-${itemId}">
                        <button class="accordion-button collapsed py-3 px-4 d-flex align-items-center bg-white w-100 text-start transition-all" 
                                type="button" 
                                data-bs-toggle="collapse" 
                                data-bs-target="#collapse-${itemId}" 
                                aria-expanded="false" 
                                aria-controls="collapse-${itemId}">
                            <span class="color-blue fw-medium me-2">${post.title}</span>
                        </button>
                    </h3>
                    <div id="collapse-${itemId}" 
                         class="accordion-collapse collapse" 
                         aria-labelledby="heading-${itemId}" 
                         data-bs-parent="#faqSearchAccordion">
                        <div class="accordion-body bg-light-gray px-4 py-3">
                            <div class="text-paragraph color-blue mb-0">
                                ${post.content}
                            </div>
                        </div>
                    </div>
                </div>
            `;
        });
        html += '</div>';
        resultsContainer.innerHTML = html;
    }

    // Chiudi i risultati cliccando fuori
    document.addEventListener('click', function(e) {
        if (!searchContainer.contains(e.target)) {
            resultsContainer.innerHTML = '';
            resultsContainer.classList.remove('show');
        }
    });
}
